import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import React, { ChangeEvent, FC, FocusEvent } from 'react';

export interface GcpDropDownItem {
  label: string;
  value: string;
}

interface GcpDropdownProps {
  label: string;
  data: GcpDropDownItem[];
  handleOnChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleOnBlur: (event: FocusEvent<HTMLInputElement>) => void;
  value: string;
  name: string;
  required: boolean;
}

const useStyles = makeStyles(
  () => ({
    root: {
      '& > div > .MuiSelect-icon': {
        top: 'auto',
        width: '1.5rem',
        height: '1.5rem',
      },
    },
  }),
  { name: 'GcpDropdown' }
);

export const GcpDropdown: FC<GcpDropdownProps> = (props) => {
  const classes = useStyles();
  const { label, data, value, handleOnBlur, handleOnChange, required, name } =
    props;

  return (
    <TextField
      fullWidth
      select
      className={classes.root}
      label={label}
      name={name}
      required={required}
      value={value}
      variant="outlined"
      onBlur={handleOnBlur}
      onChange={handleOnChange}
    >
      {data.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};
